import Text from '@root/components/v2/ui-elements/Text';
import './style.scss';
import { useHistory } from 'react-router';
import { isFunction } from 'lodash';
import { useTheme } from '@root/context/ThemeContext';
import ModuleTabs from './ModuleTabs';

function PageHeader({
  title,
  children = undefined,
  breadcrumb = false,
  path = undefined,
  subtitle = undefined,
  subtitlePath = '',
  subsubtitle = false,
  subsubtitlepath = undefined,
  subsubsubtitle = undefined,
}) {
  const history = useHistory();
  const { isDarkMode } = useTheme();

  return (
    <div className="PageHeader">
      {typeof title === 'string' ? (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Text
            element="h1"
            className="PageHeader__Title"
            font="semi-bold"
            fontSize="32px"
            style={{
              ...(breadcrumb && {
                display: 'flex',
              }),
            }}>
            <Text
              onClick={() => {
                if (path) {
                  history.push(window.location.pathname.split('/')[0] + `${path}`);
                }
              }}
              element="span"
              font="semi-bold"
              className="fs__5"
              color={isDarkMode ? '#E2E8F0' : '#1A202C'}
              style={{
                ...(breadcrumb && {
                  marginRight: '10px',
                }),
                cursor: 'pointer',
              }}>
              {title}
            </Text>
            {breadcrumb && (
              <svg
                width="9"
                height="13"
                viewBox="0 0 9 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginTop: '12px' }}>
                <path
                  d="M7.79297 7.21484L2.48828 12.5469C2.21484 12.793 1.80469 12.793 1.55859 12.5469L0.929688 11.918C0.683594 11.6719 0.683594 11.2617 0.929688 10.9883L5.14062 6.75L0.929688 2.53906C0.683594 2.26562 0.683594 1.85547 0.929688 1.60938L1.55859 0.980469C1.80469 0.734375 2.21484 0.734375 2.48828 0.980469L7.79297 6.3125C8.03906 6.55859 8.03906 6.96875 7.79297 7.21484Z"
                  fill={isDarkMode ? '#E2E8F0' : '#1A202C'}
                />
              </svg>
            )}
            {subtitle && breadcrumb && !subtitlePath && (
              <Text
                element="span"
                font="medium"
                color={isDarkMode ? '#718096' : '#A3A6AB'}
                className="fs__2"
                style={{
                  marginLeft: '10px',
                  display: 'flex',
                  borderBottom: 'none',
                  alignItems: 'center',
                  // fontWeight: '500',
                }}>
                {subtitle}
              </Text>
            )}
            {subtitle && breadcrumb && subtitlePath && (
              <Text
                onClick={() => {
                  if (subtitlePath) {
                    if (isFunction(subtitlePath)) {
                      subtitlePath();
                    } else {
                      history.push(subtitlePath);
                    }
                  }
                  // history.go(0);
                }}
                element="span"
                font="bold"
                className="fs__5"
                color={isDarkMode ? '#E2E8F0' : '#1A202C'}
                style={{
                  marginLeft: '10px',
                  display: 'flex',
                  // borderBottom: 'none',
                  alignItems: 'center',
                  cursor: 'pointer',
                  // fontWeight: '500',
                }}>
                {subtitle}
              </Text>
            )}
            {breadcrumb && subsubtitle && (
              <svg
                width="9"
                height="13"
                viewBox="0 0 9 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginTop: '12px' }}>
                <path
                  d="M7.79297 7.21484L2.48828 12.5469C2.21484 12.793 1.80469 12.793 1.55859 12.5469L0.929688 11.918C0.683594 11.6719 0.683594 11.2617 0.929688 10.9883L5.14062 6.75L0.929688 2.53906C0.683594 2.26562 0.683594 1.85547 0.929688 1.60938L1.55859 0.980469C1.80469 0.734375 2.21484 0.734375 2.48828 0.980469L7.79297 6.3125C8.03906 6.55859 8.03906 6.96875 7.79297 7.21484Z"
                  fill={isDarkMode ? '#E2E8F0' : '#1A202C'}
                />
              </svg>
            )}
            {subtitle && breadcrumb && subsubtitle && !subsubtitlepath && (
              <Text
                element="span"
                font="medium"
                color={isDarkMode ? '#718096' : '#A3A6AB'}
                className="fs__2"
                style={{
                  marginLeft: '10px',
                  display: 'flex',
                  borderBottom: 'none',
                  alignItems: 'center',
                  // fontWeight: '500',
                }}>
                {subsubtitle}
              </Text>
            )}
            {subtitle && breadcrumb && subsubtitle && subsubtitlepath && (
              <Text
                element="span"
                font="bold"
                className="fs__5"
                color={isDarkMode ? '#E2E8F0' : '#1A202C'}
                onClick={
                  () => history.push(subsubtitlepath)
                  // history.go(0);
                }
                style={{
                  marginLeft: '10px',
                  display: 'flex',
                  // borderBottom: 'none',
                  alignItems: 'center',
                  cursor: 'pointer',
                  // fontWeight: '500',
                }}>
                {subsubtitle}
              </Text>
            )}
            {breadcrumb && subsubsubtitle && (
              <svg
                width="9"
                height="13"
                viewBox="0 0 9 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginTop: '12px' }}>
                <path
                  d="M7.79297 7.21484L2.48828 12.5469C2.21484 12.793 1.80469 12.793 1.55859 12.5469L0.929688 11.918C0.683594 11.6719 0.683594 11.2617 0.929688 10.9883L5.14062 6.75L0.929688 2.53906C0.683594 2.26562 0.683594 1.85547 0.929688 1.60938L1.55859 0.980469C1.80469 0.734375 2.21484 0.734375 2.48828 0.980469L7.79297 6.3125C8.03906 6.55859 8.03906 6.96875 7.79297 7.21484Z"
                  fill={isDarkMode ? '#E2E8F0' : '#1A202C'}
                />
              </svg>
            )}
            {subtitle && breadcrumb && subsubsubtitle && (
              <Text
                element="span"
                font="medium"
                color={isDarkMode ? '#718096' : '#A3A6AB'}
                className="fs__2"
                style={{
                  marginLeft: '10px',
                  display: 'flex',
                  borderBottom: 'none',
                  alignItems: 'center',
                  // fontWeight: '500',
                }}>
                {subsubsubtitle}
              </Text>
            )}
          </Text>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {title}
        </div>
      )}

      <ModuleTabs />

      <div className="PageHeader__ContentContainer">{children}</div>
    </div>
  );
}

export default PageHeader;
